<div class="question-type-holder">
  <span class="icon-holder">
      <i class="ae {{typeData?.icon}}"></i>
  </span>
  <span class="label-content">
    {{ typeData?.questionTypeName}}
  </span>
</div>